import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html',
    standalone: false
})
export class FullLayoutComponent { }
